import React from "react";
import MoneyStreamlineChart from "../MoneyStreamlineChart";
import { getLanguageContent } from "../../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../../utils/schemas/language/pages/personalFinancesSchema";

const SpendingChartWithLegend = ({
  currentMonthData,
  previousMonthData,
  averageData,
  height,
  showAverage = true,
  currentLabel,
  previousLabel,
  averageLabel,
}) => {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const legends = content.overview.money_flow.legends;
  const resolvedCurrentLabel = currentLabel || legends.current_month;
  const resolvedPreviousLabel = previousLabel || legends.previous_month;
  const resolvedAverageLabel = averageLabel || legends.average_six_months;

  const LegendItem = ({ label, color, type, isCurrent }) => (
    <div className="legend-item-box">
      <div className="legend-line-wrapper">
        <div
          className="legend-line-segment"
          style={{
            backgroundColor: type === "dashed" ? "transparent" : color,
            borderTop: type === "dashed" ? `2px dashed ${color}` : "none",
          }}
        />
      </div>
      <span
        className={`legend-item-text ${
          isCurrent ? "current-active" : "standard-inactive"
        }`}
      >
        {label}
      </span>
    </div>
  );

  return (
    <div className="spending-chart-legend-wrapper">
      <MoneyStreamlineChart
        currentMonthData={currentMonthData}
        previousMonthData={previousMonthData}
        averageData={showAverage ? averageData : null}
      />

      <div className="spending-chart-legend-container">
        {showAverage && (
          <LegendItem
            label={resolvedAverageLabel}
            color="#E5E7EB"
            type="solid"
          />
        )}
        <LegendItem
          label={resolvedCurrentLabel}
          color="#3B82F6"
          type="solid"
          isCurrent
        />
        <LegendItem
          label={resolvedPreviousLabel}
          color="#F5A623"
          type="dashed"
        />
      </div>
    </div>
  );
};

export default SpendingChartWithLegend;
